(function () {


    function viewport() {
        var e = window, a = 'inner';
        if (!('innerWidth' in window)) {
            a = 'client';
            e = document.documentElement || document.body;
        }
        return { width: e[a + 'Width'], height: e[a + 'Height'] };
    }

    document.querySelectorAll(".formblock").forEach(form => {
        const btn = form.querySelector(".pBtn");
        const container = form.querySelector(".form-container")
        const submit = form.querySelector("input[type='submit']");
        if (submit) {
            submit.style.backgroundColor = "#" + form.getAttribute("btn-color");

            if (btn) {
                window.addEventListener("resize", () => {
                    setFormPosition(container);
                })
                btn.addEventListener("click", () => {
                    container.classList.add("show")
                    setFormPosition(container)
                    btn.classList.add("hide");
                })
                const closeButton = form.querySelector("button.close")
                if (closeButton) {
                    closeButton.addEventListener("click", () => {
                        container.classList.remove("show")
                        btn.classList.remove("hide");
                    })
                }
            }
        }
    })

    document.addEventListener("keyup", (e) => {
        if (e.key === "Escape") {
            document.querySelectorAll(".formblock").forEach(form => {
                const btn = form.querySelector(".pBtn");
                console.log(btn)
                const container = form.querySelector(".form-container")
                if (container.classList.contains("show")) {
                    container.classList.remove("show")
                    btn.classList.remove("hide");
                }
            })
        }
    })
    function setFormPosition(container) {
        //document.querySelectorAll(".formblock.popup").forEach(form => {
        //const container = form.querySelector(".form-container")
        if (container.querySelector("#umbraco-forms-form-submitted")) {
            container.classList.add("show")
            const closeButton = form.querySelector("button.close")
            if (closeButton) {
                closeButton.classList.add("hide")
            }
            const btn = form.querySelector(".pBtn");
            btn.classList.add("hide");
        }
        const vpWidth = container.closest(".area-container").offsetWidth;
        if (vpWidth <= 500) {
            container.style.marginLeft = "0";
            container.style.marginRight = "0";
        } else {
            //const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
            //const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
            //console.log(vpWidth, container.offsetWidth);
            const margin = (vpWidth - container.offsetWidth) / 2
            container.style.marginLeft = margin + "px";
            container.style.marginRight = margin + "px";
        }
        const body = container.closest("body")
        if (!body.classList.contains("tourism")) {
            container.style.top = "-200px";
        }
        //console.log("form scrollIntoView")
        container.scrollIntoView()
        //})

    }

    //window.addEventListener("resize", () => {
    //    setFormPosition();
    //})

    //setFormPosition();


})();